import { Configuration, PublicClientApplication } from '@azure/msal-browser';

export const loginRequest = {
  scopes: ['User.Read'],
};

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.AZURE_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${process.env.AZURE_TENANT_ID}`,
    knownAuthorities: ['login.microsoftonline.com'],
    redirectUri: process.env.AZURE_REDIRECT_CMS_URI || '',
    postLogoutRedirectUri: process.env.AZURE_REDIRECT_CMS_URI,
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored sessionStorage / memoryStorage
    // storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  },
};
const msalInstance = new PublicClientApplication(msalConfig);

export { msalInstance };
